import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'troly_cart_v1';
const Ctx = createContext(null);

// Cada item del carrito representa una pieza de un seller. La compra final se
// concreta llamando a /api/orders por cada item con la información de envío.
//   { publicationId, listingId, name, image, price, currency,
//     sellerId, sellerName, units (max disponibles), qty (cantidad seleccionada) }
// `price` es el monto canónico (en `currency`); el carrito NO convierte —
// la presentación corre por cuenta de <Price> con la divisa del usuario.
export function CartProvider({ children }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) setItems(JSON.parse(raw) || []);
    } catch { /* ignore */ }
  }, []);

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); }
    catch { /* ignore */ }
  }, [items]);

  const addItem = useCallback((piece) => {
    setItems((prev) => {
      const i = prev.findIndex((it) => it.publicationId === piece.publicationId);
      if (i >= 0) {
        const next = [...prev];
        const cap = next[i].units || 1;
        next[i] = { ...next[i], qty: Math.min(cap, (next[i].qty || 1) + 1) };
        return next;
      }
      return [...prev, { ...piece, qty: 1 }];
    });
  }, []);

  const setQty = useCallback((publicationId, qty) => {
    setItems((prev) => prev.map((it) => {
      if (it.publicationId !== publicationId) return it;
      const cap = it.units || 1;
      const n = Math.max(1, Math.min(cap, Number(qty) || 1));
      return { ...it, qty: n };
    }));
  }, []);

  const removeItem = useCallback((publicationId) => {
    setItems((prev) => prev.filter((it) => it.publicationId !== publicationId));
  }, []);

  const clear = useCallback(() => setItems([]), []);

  const count = items.reduce((s, it) => s + (it.qty || 1), 0);
  const total = items.reduce((s, it) => s + (Number(it.price) || 0) * (it.qty || 1), 0);
  const has = (publicationId) => items.some((it) => it.publicationId === publicationId);

  return (
    <Ctx.Provider value={{ items, addItem, setQty, removeItem, clear, count, total, has }}>
      {children}
    </Ctx.Provider>
  );
}

export const useCart = () => useContext(Ctx);
